module.exports = __webpack_public_path__ + "media/images/icons/channel_managers-179da816e1a03a139e20b22cb1a493b6.svg";